export enum AuthenticatorType {
    Totp = 'totp',
}
